import React from 'react'
import Box from '@mui/material/Box'
import Alert, { AlertColor } from '@mui/material/Alert'
import IconButton from '@mui/material/IconButton'
import Collapse from '@mui/material/Collapse'
import CloseIcon from '@mui/icons-material/Close'
import { SxProps } from '@mui/material'

interface Props {
  children: JSX.Element[] | JSX.Element
  sx: SxProps
  severity: AlertColor | undefined
  setOpenCustomAlert : React.Dispatch<React.SetStateAction<boolean>>
  openCustomAlert : boolean,
}

export const CustomAlert: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  sx = { width: '100%' },
  severity = 'info',
  setOpenCustomAlert,
  openCustomAlert

}) => {

  return (
    <Box sx={sx}>
      <Collapse in={openCustomAlert}>
        <Alert
          severity={severity}
          action={
            <IconButton
              aria-label='close'
              color='inherit'
              size='small'
              onClick={() => {
                setOpenCustomAlert(false)
              }}
            >
              <CloseIcon fontSize='inherit' />
            </IconButton>
          }
          sx={{ mb: 2 }}
        >
          {children}
        </Alert>
      </Collapse>
    </Box>
  )
}
